import { Route, Switch } from 'wouter';
import AuthRoute from './AuthRoute';
import * as paths from './paths';
import { useAnalyticsListener } from '~/components/analytics/routes';
import { useParameterListener } from '~/components/context';
import HealthCheck from '~/components/error/healthcheck';
import {
  EntryPage,
  ProductsPage,
  LogoutPage,
  PasswordReset,
  ConfirmEmail,
  RequestPasswordReset,
} from '~/pages';

const Routes = () => {
  useParameterListener();
  useAnalyticsListener();

  return (
    <Switch>
      <AuthRoute component={ProductsPage} path={paths.PRODUCTS} />
      <Route component={LogoutPage} path={paths.LOGOUT} />
      <Route component={PasswordReset} path={paths.PASSWORD_RESET} />
      <Route component={RequestPasswordReset} path={paths.FORGOT_PASSWORD} />
      <Route component={ConfirmEmail} path={paths.CONFIRM_EMAIL} />
      <Route component={HealthCheck} path={paths.HEALTHCHECK} />
      <Route>
        <EntryPage />
      </Route>
    </Switch>
  );
};
export default Routes;
